import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { BookingOrderService } from '../../services/booking-order.service';
import { CompanyInfoStateService } from '../../../contact/services/company-info-state.service';

@Component({
  selector: 'app-booking-contact-us',
  templateUrl: './booking-contact-us.component.html',
  styleUrls: ['./booking-contact-us.component.css']
})
export class BookingContactUsComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  description: string;

  constructor(
    private bookingOrderService: BookingOrderService,
    private companyInfoStateService: CompanyInfoStateService,
    private router: Router,
  ) { }

  ngOnInit() {
  }

  navigateToContactForm() {
    this.router.navigateByUrl(environment.contactFormUrl);
  }

  get maxPersonCount(): number {
    return this.bookingOrderService.eventCache.maxPersonCount;
  }

  get phone(): string {
    if (this.companyInfoStateService.companyInfo) {
      return this.companyInfoStateService.companyInfo.phone;
    }
    return '';
  }
}
